

export class CacheService {

    static set(name, data, ttlMs) {
        const payload = {
            data,
            expiry: Date.now() + ttlMs,
        };

        const serialized = JSON.stringify(payload);

        try {

            localStorage.setItem(name, serialized);

        } catch (e) {

            if (e.name === 'QuotaExceededError' || e.code === 22 || e.code === 1014) {

                this.purgeExpired();

                try {

                    localStorage.setItem(name, serialized);

                } catch (retryError) {

                    this.freeUpSpace(serialized.length);

                    try {

                        localStorage.setItem(name, serialized);

                    } catch (finalError) {
                        
                        console.error(`[Storage] Failed to save "${name}" even after clearing:`, finalError);
                    }
                }
            } else {
                throw e;
            }
        }
    }

    static get(name) {

        const cached = localStorage.getItem(name);
        if (!cached) { return null;}

        try {
            const { data, expiry } = JSON.parse(cached);

            if (Date.now() > expiry) {

                localStorage.removeItem(name);
                return null;

            } else {

                return data;

            }
        } catch (err) {

            localStorage.removeItem(name);
            return null;
        }
    }

    static purgeExpired() {

        const now = Date.now();
        
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (!key) { continue;}

            try {
                const item = JSON.parse(localStorage.getItem(key));
                if (item && typeof item === 'object' && item.expiry && item.expiry < now) {
                    localStorage.removeItem(key);
                }
            } catch (_) {
            }
        }
    }

    static freeUpSpace() {
        localStorage.clear();
    }
}